// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon--big[data-v-3a3802d6]{height:164px;width:164px}.icon--small[data-v-3a3802d6]{height:112px;width:112px}", ""]);
// Exports
module.exports = exports;
